var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSize11 = function SvgIconSize11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 1,
    y: 1,
    stroke: "#777E90",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M7.448 16.5V8.316l.528.408H5.504V7.74H8.6v8.76zm3.467 0v-1.464h1.392V16.5zm0-4.44v-1.464h1.392v1.464zm4.713 4.44V8.316l.528.408h-2.472V7.74h3.096v8.76z"
  })));
};
export default SvgIconSize11;